
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43.82 43.777"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 923"}},[_c('path',{attrs:{"data-name":"Path 7088","d":"M43.82 18.718v-2.654a.722.722 0 00-.4-.65L12.744.077a.725.725 0 00-.65 0L.4 5.923a.722.722 0 00-.4.65V9.2l5.452 2.73L.4 14.447a.732.732 0 00-.4.65v2.627l7.241 3.629L.4 24.777a.732.732 0 00-.4.65v2.627l27.576 13.8 3.1 1.566.693.351 1.84-.907 7.763-3.877 1.386-.693 1.464-.727v-2.648a.722.722 0 00-.4-.65l-6.83-3.415 4.382-2.191 1.386-.693 1.464-.727v-2.654a.722.722 0 00-.4-.65l-5.032-2.516 2.578-1.293 1.386-.693zM12.418 1.549l29.45 14.721-6.9 3.449-1.635.813-1.933.968-20.916-10.459-1.634-.814-6.9-3.449zm29.938 35.107L31.4 42.134 1.464 27.165V26.2l29.783 14.89a.363.363 0 00.325 0l10.793-5.39v.959zm-.488-1.532l-10.458 5.23L1.951 25.633l6.915-3.458 18.7 9.363 3.1 1.566.693.351 1.84-.907 1.746-.873zm.488-8.79l-7.4 3.706-1.635.813-1.917.959L10.5 21.362l-1.635-.813-7.4-3.7v-.967l8.37 4.185 1.635.813 19.77 9.885a.363.363 0 00.325 0l.787-.394 1.635-.813 8.37-4.185v.959zm-.488-1.534l-8.687 4.35-1.635.813-.137.068-19.128-9.56-1.635-.813L1.951 15.3l5.127-2.559 20.5 10.262 3.1 1.566.693.351 1.84-.907 3.543-1.772zM31.4 23.288L8.7 11.931l-1.635-.813L1.464 8.31v-.967l6.572 3.287 1.635.813 21.576 10.784a.363.363 0 00.325 0l2.585-1.292 1.635-.813 6.573-3.286v.964z","fill":"#3d9ed3"}})])])
          )
        }
      }
    